import type { FC } from "react";
import React, { memo, useCallback } from "react";
import type { PricePromotionType } from "../../../../../../../common-deprecated/types/CommonTypes";
import { useAemNavOffset } from "../../../../../../../common-deprecated/hooks";
import { scrollTargetIntoView } from "../../../../../../../common-deprecated/utils";
import styles from "./CashPrice.module.scss";
import { useCarConfigLabel } from "../../../../utils/labelUtils";

const PromotionNumbers: FC<{ promotions: PricePromotionType[] }> = ({ promotions }) => {
    const navOffset = useAemNavOffset();

    const onPromotionClick = useCallback(
        (id: string) => (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
            event.preventDefault();
            event.stopPropagation();
            scrollTargetIntoView(id, navOffset, false, true);
        },
        [navOffset],
    );

    const promotionDisclaimerLabel = useCarConfigLabel("ariaSkipToPromoDisclaimer");

    return (
        <span>
            {promotions.map((promotion) => (
                <button
                    key={promotion.id}
                    type="button"
                    onClick={onPromotionClick(promotion.id)}
                    className={styles.button}
                    aria-label={`${promotionDisclaimerLabel} ${promotion.index}`}
                >
                    {promotion.index}
                </button>
            ))}
        </span>
    );
};

export default memo(PromotionNumbers);
